module.exports = __webpack_public_path__ + "img/renga-image-text.43cd01a4.png";